module.exports = __webpack_public_path__ + "img/chat-gpt-integration-cover.c0f7134f.jpeg";